<template>
	<div>
		<sBox title="Filtrar Status Vacinação">
			<div slot="body">
				<!-- <br> -->
				<!-- <sBox title='Filtrar Status Vacinação'> -->
				<div class="row" slot="body">
					<div class="col-md-2">
						<span>Nome</span>
						<input
							v-model="filter.nome_vacina"
							@input="
								fxFilter('nome_vacina', $event.target.value)
							"
							type="text"
							class="form-control"
							placeholder="NOME"
						/>
					</div>
					<div class="col-md-3">
						<span>Tecnologia</span>
						<input
							v-model="filter.tecnologia"
							@input="fxFilter('tecnologia', $event.target.value)"
							type="text"
							class="form-control"
							placeholder="TECNOLOGIA"
						/>
					</div>
					<div class="col-md-2">
						<span>Eficácia</span>
						<input
							max="100"
							v-model="filter.eficacia"
							@input="fxFilter('eficacia', $event.target.value)"
							type="number"
							class="form-control"
							placeholder="EFICÁCIA"
						/>
					</div>

					<div class="col-md-2">
						<span>Dosagem</span>
						<input
							v-model="filter.dosagem"
							@input="fxFilter('dosagem', $event.target.value)"
							type="text"
							class="form-control"
							placeholder="DOSAGEM"
						/>
					</div>

					<div class="col-md-3">
						<span>Armazenamento</span>
						<input
							v-model="filter.armazenamento"
							@input="
								fxFilter('armazenamento', $event.target.value)
							"
							type="text"
							class="form-control"
							placeholder="ARMAZENAMENTO"
						/>
					</div>
				</div>
				<!-- </sBox> -->

				<br />
				<div class="box-excel-export">
					<aBtn
						action="private-save-status_vacinacao"
						@click="$refs.modal.open()"
						text="Status Vacinação"
						icon="plus"
						size="sm"
						type="success"
					/>
				</div>

				<br />
				<sTable
					ref="tab"
					actionRead="private-read-status_vacinacao"
					actionDelete="private-delete-status_vacinacao"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					@edit="
						(data) => {
							$refs.modal.open(data);
						}
					"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
		<modal2 ref="modalExcel" id="modal2" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';
	import modal2 from './modal2.vue';
	import pad from 'js/pad';
	var XLSX = require('xlsx');

	export default {
		name: 'AppCadastroStatusVacinacao',
		components: { sTable, sBox, modal, aBtn, modal2 },
		data() {
			return {
				labels: [
					{ data: 'id', label: 'ID' },
					{ data: 'nome_vacina', label: 'NOME' },
					{ data: 'eficacia', label: 'EFICÁCIA' },
					{ data: 'dosagem', label: 'DOSAGEM' },
					{ data: 'armazenamento', label: 'ARMAZENAMENTO' },
					{ data: 'tecnologia', label: 'TECNOLOGIA' },
				],
				// functions: [
				// 	{ cod: 'cod', fx: (val)=>{return pad(val, 5)} }
				// ]

				filter: {
					id: '',
					nome_vacina: '',
					eficacia: '',
					dosagem: '',
					armazenamento: '',
					tecnologia: '',
					// nome_tipo_vacina: '',
				},
			};
		},
		methods: {
			fxFilter(col, val) {
				let f = [];

				if (this.filter.nome_vacina != '')
					f.push(
						`LOWER(nome_vacina) like LOWER('%${this.filter.nome_vacina}%')`
					);

				if (this.filter.eficacia != '')
					f.push(
						`LOWER(eficacia) like LOWER('%${this.filter.eficacia}%')`
					);

				if (this.filter.dosagem != '')
					f.push(
						`LOWER(dosagem) like LOWER('%${this.filter.dosagem}%')`
					);

				if (this.filter.armazenamento != '')
					f.push(
						`LOWER(armazenamento) like LOWER('%${this.filter.armazenamento}%')`
					);

				if (this.filter.tecnologia != '')
					f.push(
						`LOWER(tecnologia) like LOWER('%${this.filter.tecnologia}%')`
					);

				// if(this.filter.nome_tipo_vacina != '')
				// 	f.push( `nome_tipo_vacina like '%${this.filter.nome_tipo_vacina}%'` )

				f = f.join(' and ');

				// console.log(f)

				console.log(f);

				if (f != '') this.$refs.tab.setFilter(f);
				else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},

			handleConvertTableToXLS() {
				const mainTable = document.querySelector('.table');
				console.log(mainTable);

				const jsonExcelData = XLSX.utils.table_to_book(mainTable);

				console.log(jsonExcelData);

				const nameOfFile = 'Dados-de-status-vacinacao.xlsx';

				XLSX.writeFile(jsonExcelData, nameOfFile);
			},
		},
		mounted() {
			this.$emit('setHeader', ['Gerenciamento de Status Vacinação', '']);
		},
	};
</script>

<style>
	.box-excel-export {
		width: 100%;
		display: flex;
		justify-content: end;
	}

	.btn-import {
		margin-left: 15px;
	}

	.btn-export {
		filter: saturate(1.5);
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/status_vacinacao/index.vue